
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
export default function Index (props:any) {

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        token: {
          // colorBorder:'#3F8CFF',
          colorPrimary:'#3F8CFF',
        },
        // colorBorder:'#009580',
        components: {
          Button: {
            primaryShadow:'0 0 0',
            colorPrimary:'#3F8CFF',
            colorLink:'#3F8CFF',
            algorithm: true, // 启用算法
          },
          Input: {
            // activeBorderColor: '#009580'
          },
          Layout: {
            headerPadding: '0 20px'
          },
          Spin:{
            // contentHeight: 600
          },
          Form:{
            itemMarginBottom:10,
            labelColor:'#3f3f3fe0',
          }
        },
      }}
    >
      {props.children}
    </ConfigProvider>
  )
}